import { mergeObjects } from '@gn-audio/angularjs-components/was-this-useful/utilities/merge-objects';
import { getWtuAdditionalInfo } from './get-wtu-additional-info';
export var setWtuAdditionalInfo = function (sendModel, product) {
    var wtuAdditionalInfo = getWtuAdditionalInfo(product);
    mergeObjects(sendModel, wtuAdditionalInfo);
};
